function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M212.6 21.3H70.9v28.3h21.3v184.3c0 27.4 22.2 49.6 49.6 49.6s49.6-22.2 49.6-49.6V49.6h21.3l-.1-28.3zm-70.9 233.8c-11.7 0-21.3-9.4-21.3-21.2V115.5H163v118.3c0 11.8-9.5 21.3-21.3 21.3.1 0 0 0 0 0zM163 101.4h-42.6V49.6H163v51.8z"
})));